import "./Hero.css";
import ClockIcon from "../img/clock-icon.svg";
import PhoneIcon from "../img/phone-icon.svg";
import MailIcon from "../img/email-icon.svg";

import { contactActions } from "../store";
import { useDispatch } from "react-redux";

export default function Hero() {
  const dispatch = useDispatch();

  const openContactForm = () => {
    dispatch(contactActions.openContactForm());
  };

  return (
    <div className="hero-section">
      <div className="hero-text">
        <h1>
          ΔΙΚΗΓΟΡΙΚΟ ΓΡΑΦΕΙΟ
          <br /> <span>ΣΟΡΤΟΓΛΟΥ ΧΑΛΝΤΟΥΝ</span>
        </h1>
        <p>
          Η προσέγγιση που καλύπτει την αριστεία στην επιστήμη και παρέχει
          υψηλού επιπέδου νομικές υπηρεσίες αποτελεί κεντρική αξία του γραφείου
          μας.
          <br /> Το γραφείο μας διατηρεί μόνιμη συνεργασία με δικηγορικά γραφεία
          στην Κωνσταντινούπολη Τουρκίας και Στουτγάρδη Γερμανίας, ειδικευμένο
          σε υποθέσεις διασυνοριακού χαρακτήρα.
        </p>
        <button className="btn" onClick={openContactForm}>
          ΕΠΙΚΟΙΝΩΝΗΣΤΕ ΤΩΡΑ
        </button>
      </div>
      <div className="hero-contact">
        <div className="contact-container">
          <div className="contact-icon-box">
            <img src={ClockIcon} alt="Working Hours Icon" />
          </div>
          <div className="contact-details">
            <p className="contact-title">'Ωρες Λειτουργίας</p>
            <p className="contact-description">Δευ - Παρ (08:00 - 20:00)</p>
          </div>
        </div>
        <div className="contact-container">
          <div className="contact-icon-box">
            <img src={PhoneIcon} alt="Working Hours Icon" />
          </div>
          <div className="contact-details">
            <p className="contact-title">Τηλέφωνα Επικοινωνίας</p>
            <p className="contact-description">2532012345 & 6940404044</p>
          </div>
        </div>
        <div className="contact-container">
          <div className="contact-icon-box">
            <img src={MailIcon} alt="Working Hours Icon" />
          </div>
          <div className="contact-details">
            <p className="contact-title">Email</p>
            <p className="contact-description">abcdf@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}
